import React from 'react'

export const BorderTopIcon = () => {
  return (
    <svg width="51" height="51" viewBox="0 0 51 51" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="path-1-inside-1_648_1591" fill="white">
        <path d="M0.332031 10.6851C0.332031 5.16221 4.80918 0.685059 10.332 0.685059H50.332V50.6851H0.332031V10.6851Z" />
      </mask>
      <path d="M-0.667969 10.6851C-0.667969 4.60993 4.2569 -0.314941 10.332 -0.314941H50.332V1.68506H10.332C5.36147 1.68506 1.33203 5.7145 1.33203 10.6851H-0.667969ZM50.332 50.6851H0.332031H50.332ZM-0.667969 50.6851V10.6851C-0.667969 4.60993 4.2569 -0.314941 10.332 -0.314941V1.68506C5.36147 1.68506 1.33203 5.7145 1.33203 10.6851V50.6851H-0.667969ZM50.332 0.685059V50.6851V0.685059Z" fill="black" mask="url(#path-1-inside-1_648_1591)" />
    </svg>
  )
}
